import { Component, Input, Output, EventEmitter, inject, OnInit } from '@angular/core';

import { MenuItem } from 'primeng/api';
import { LanguageService } from '@shared/services/language/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { MenuModule } from 'primeng/menu';

interface Language {
  label: string;
  value: string;
  code: string;
}

@Component({
    selector: 'app-header',
    imports: [TranslateModule, MenuModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() title: string = '';
  @Input() userName: string = '';
  @Input() isDarkTheme: boolean = false;
  @Output() themeToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() menuToggle: EventEmitter<void> = new EventEmitter<void>();

  private languageService: LanguageService = inject(LanguageService);

  currentLanguage: string = 'es';

  languages: Language[] = [
    { label: 'Español', value: 'es', code: 'ES' },
    { label: 'English', value: 'en', code: 'EN' },
    { label: 'Português', value: 'pt', code: 'PT' }
  ];

  menuItems: MenuItem[] = [];

  ngOnInit(): void {
    // Cargar el idioma guardado o usar el por defecto
    this.currentLanguage = this.languageService.getCurrentLanguage();
    
    // Inicializar items del menú
    this.buildMenuItems();
  }

  private buildMenuItems(): void {
    this.menuItems = this.languages.map(lang => ({
      label: lang.label,
      code: lang.code,
      command: () => this.changeLanguage(lang.value)
    }));
  }

  changeLanguage(lang: string): void {
    this.currentLanguage = lang;
    this.languageService.setLanguage(lang);
  }

  getCurrentCode(): string {
    const currentLang: Language | undefined = this.languages.find(lang => lang.value === this.currentLanguage);
    return currentLang ? currentLang.code : 'ES';
  }

  toggleTheme() {
    this.themeToggle.emit();
  }

  onMenuToggle() {
    this.menuToggle.emit();
  }
} 